/**
 * Updates every `<meta property="og:image">` and `<meta name="twitter:image">`
 * tag with a `?v={n}` cache-buster fetched from /api/seo/og-version.
 *
 * Why: LinkedIn / Twitter / WhatsApp / Facebook aggressively cache OG images.
 * After regenerating /public/og/*.png we bump the version via admin and this
 * function forces all crawlers to refetch on their next preview scrape.
 *
 * Failure tolerated — OG cache busting is a best-effort optimisation.
 */
import { useEffect } from "react";
import { api } from "@/lib/api";

export default function useOgVersionUpdater() {
  useEffect(() => {
    let cancelled = false;
    api.get("/seo/og-version").then((r) => {
      if (cancelled) return;
      const v = Number(r.data?.version) || 1;
      if (v <= 1) return; // no-op on default version
      document.querySelectorAll('meta[property="og:image"], meta[name="twitter:image"]').forEach((tag) => {
        const cur = tag.getAttribute("content");
        if (!cur || cur.includes(`v=${v}`)) return;
        const sep = cur.includes("?") ? "&" : "?";
        // Strip any previous v= param so we don't accumulate
        const cleaned = cur.replace(/[?&]v=\d+/, "");
        const cleanSep = cleaned.includes("?") ? "&" : "?";
        tag.setAttribute("content", `${cleaned}${cleanSep}v=${v}`);
      });
    }).catch(() => { /* OG cache-bust is best-effort */ });
    return () => { cancelled = true; };
  }, []);
}
